export const environment = {
	production: false,
	/** O ambiente de desenvolvimento do back-end. Ver `environment.ts` para a rota de produção. */
	apiUrl: 'https://api.dev.nexpo.soft2code.com',
	/**
	 * Ligado de propósito: a imagem do develop é a demonstração do app.
	 *
	 * O visitante usa a feira sem conta, e a API ainda não tem leitura pública
	 * (história NEXPO-API-09). Sem os dados de exemplo, o develop não teria
	 * feira nenhuma para mostrar. Com eles, cada tela leva a tarja de
	 * demonstração — o dado simulado nunca se passa por real.
	 */
	useMockData: true,
} as const;
